import { useEffect, useState } from 'react'
import { ClassicPropertySearchBox } from '@/components/search/ClassicPropertySearchBox'
import { PlacesPropertySearchBox } from '@/components/search/PlacesPropertySearchBox'
import { getSearchBackend, type SearchBackend } from '@/lib/search-backend'

/**
 * Property directory search. Switches between classic Firestore prefix
 * and Places → resolve based on appConfig/search.backendV2.
 */
export function PropertySearchBox({
  autoFocus,
  className,
  placeholder = 'Search any Australian address…',
}: {
  autoFocus?: boolean
  className?: string
  placeholder?: string
}) {
  // Assume v2 immediately so the home search bar shows its placeholder on
  // first paint; swap to classic only if remote config later says so.
  const [backend, setBackend] = useState<SearchBackend>('v2')

  useEffect(() => {
    let cancelled = false
    getSearchBackend().then((b) => {
      if (!cancelled) setBackend(b)
    })
    return () => {
      cancelled = true
    }
  }, [])

  if (backend === 'classic') {
    return (
      <ClassicPropertySearchBox
        autoFocus={autoFocus}
        className={className}
        placeholder={placeholder}
      />
    )
  }

  return (
    <PlacesPropertySearchBox
      autoFocus={autoFocus}
      className={className}
      placeholder={placeholder}
    />
  )
}
